module.exports = __webpack_public_path__ + "static/img/fish27.16c6946.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish27.png
// module id = lLYZ
// module chunks = 0